const FA_HEALTH_METRIC_NAMES: Record<string, string> = {
  'body fat': 'چربی بدن',
  'body fat mass': 'جرم چربی بدن',
  'body fat percentage': 'درصد چربی بدن',
  'body mass index': 'شاخص توده بدنی',
  bmi: 'شاخص توده بدنی',
  'extracellular water': 'آب خارج‌سلولی',
  'fat free mass': 'توده بدون چربی',
  'intracellular water': 'آب داخل‌سلولی',
  'lean body mass': 'توده بدون چربی بدن',
  'left arm fat': 'چربی بازوی چپ',
  'left arm lean': 'توده بدون چربی بازوی چپ',
  'left leg fat': 'چربی پای چپ',
  'left leg lean': 'توده بدون چربی پای چپ',
  'metabolic age': 'سن متابولیک',
  'mineral mass': 'توده مواد معدنی',
  'muscle mass': 'توده عضلانی',
  'percent fat': 'درصد چربی بدن',
  'percent body fat': 'درصد چربی بدن',
  'protein mass': 'توده پروتئین',
  'right arm fat': 'چربی بازوی راست',
  'right arm lean': 'توده بدون چربی بازوی راست',
  'right leg fat': 'چربی پای راست',
  'right leg lean': 'توده بدون چربی پای راست',
  'skeletal muscle mass': 'توده عضلانی اسکلتی',
  'total body water': 'آب کل بدن',
  'trunk fat': 'چربی تنه',
  'trunk lean': 'توده بدون چربی تنه',
  'visceral fat': 'چربی احشایی',
  bmr: 'سوخت‌وساز پایه',
  weight: 'وزن',
  "appetite": "اشتها",
  "body battery": "ذخیره انرژی بدن",
  "bust": "دور بالاتنه",
  "fatigue": "خستگی",
  "glutes": "عضلات باسن",
  "hydration level": "سطح آب‌رسانی بدن",
  "injury": "آسیب‌دیدگی",
  "left bicep": "دور بازوی چپ",
  "left calf": "دور ساق چپ",
  "left forearm": "دور ساعد چپ",
  "left thigh": "دور ران چپ",
  "left wrist": "دور مچ چپ",
  "menstruation": "قاعدگی",
  "mood": "خلق‌وخو",
  "motivation": "انگیزه",
  "overall feeling": "احساس کلی",
  "restwise score": "امتیاز رست‌وایز",
  "right bicep": "دور بازوی راست",
  "right calf": "دور ساق راست",
  "right forearm": "دور ساعد راست",
  "right wrist": "دور مچ راست",
  "shoulder": "دور شانه",
  "sickness": "بیماری",
  "skin fold": "ضخامت چین پوستی",
  "sleep elevation": "ارتفاع هنگام خواب",
  "sleep hours": "مدت خواب",
  "sleep quality": "کیفیت خواب",
  "soreness": "کوفتگی عضلانی",
  "stress": "استرس",
  "stress level": "سطح استرس",
  "time in deep sleep": "مدت خواب عمیق",
  "time in light sleep": "مدت خواب سبک",
  "time in rem sleep": "مدت خواب با حرکات سریع چشم",
  "times woken": "تعداد بیدار شدن",
  "torso": "تنه",
  "total time awake": "مجموع زمان بیداری",
  "urine color": "رنگ ادرار",
  "water consumption": "مصرف آب",
  "consumed calories": "کالری مصرف‌شده",
  "bone mineral content": "محتوای معدنی استخوان",
  "waist hip ratio": "نسبت دور کمر به باسن",
  "android fat": "چربی ناحیه شکمی",
  "gynoid fat": "چربی ناحیه لگن و ران",
  "max heart rate": "حداکثر ضربان قلب",
  "resting heart rate": "ضربان قلب استراحت",
  "lactate threshold": "آستانه لاکتات",
  "anaerobic threshold": "آستانه بی‌هوازی",
  "ventilatory threshold": "آستانه تهویه‌ای",
  "uric acid": "اسید اوریک",
  "hematocrit": "هماتوکریت",
  "ferritin": "فریتین",
  "iron": "آهن",
  "vitamin d": "ویتامین دی",
  "creatinine": "کراتینین",
  "cortisol": "کورتیزول",
  "testosterone": "تستوسترون",
  "soft lean mass": "توده نرم بدون چربی",
  "body type": "نوع بدن",
  "stroke rate": "نرخ حرکت دست در شنا",
  "distance per stroke": "مسافت هر حرکت دست",
  "stroke index": "شاخص حرکت دست",
  "strokes per length": "تعداد حرکت دست در هر طول",
  "maximum aerobic speed": "بیشینه سرعت هوازی",
  "running economy": "اقتصاد دویدن",
  "d prime": "ذخیره مسافت بالاتر از سرعت بحرانی",
  "running cadence": "آهنگ گام دویدن",
  "stride length": "طول گام",
  "ground contact time": "زمان تماس با زمین",
  "vertical oscillation": "نوسان عمودی",
  "blood lactate": "لاکتات خون",
  "watts per kilogram": "وات بر کیلوگرم",
  "w prime": "ذخیره کار بالاتر از توان بحرانی",
  "power 5 second": "توان ۵ ثانیه",
  "power 1 minute": "توان ۱ دقیقه",
  "power 5 minute": "توان ۵ دقیقه",
  "power 20 minute": "توان ۲۰ دقیقه",
  "gross efficiency": "بازده ناخالص",
  "pedaling cadence": "آهنگ رکاب‌زدن",
};

function normalizeMetricName(value: string) {
  return value
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .toLocaleLowerCase('en-US');
}

export function presentHealthMetricName(name: string | undefined, language: string) {
  const fallback = name?.trim() || (language.startsWith('fa') ? 'متریک' : 'Metric');
  if (!language.startsWith('fa')) return fallback;
  return FA_HEALTH_METRIC_NAMES[normalizeMetricName(fallback)] ?? fallback;
}
